import { render, staticRenderFns } from "./RepairTypeForm.vue?vue&type=template&id=11072522"
import script from "./RepairTypeForm.vue?vue&type=script&lang=js"
export * from "./RepairTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports